import { tv } from 'tailwind-variants';

// ─── SearchBar (header dropdown) ─────────────────────────────────────────────

export const searchBarVariants = tv({
  slots: {
    container: ['relative w-full'],
    form: ['flex items-center w-full'],
    inputWrapper: ['relative flex items-center grow'],
    // Real <button type="submit"> so the form has a programmatic submission trigger (WCAG); visually it is just the magnifier icon
    iconButton: [
      'absolute left-0 top-0 h-full px-2.5',
      'flex items-center',
      'cursor-pointer',
      'focus-visible:outline-2 focus-visible:outline-secondary rounded-[5px]',
    ],
    icon: ['fa-solid fa-magnifying-glass', 'text-[15px] text-secondary'],
    input: [
      'w-full',
      'pl-8 pr-3 py-1.25',
      'border border-[#dedede] rounded-[5px]',
      'text-sm text-textPrimary font-semibold text-[16px] leading-6',
    ],
    clearButton: [
      'absolute right-2.5',
      'fa-solid fa-xmark',
      'text-sm text-secondary cursor-pointer',
      'hover:text-gray-600',
    ],
    spinner: [
      'absolute right-2.5 w-4 h-4',
      'border-2 border-[#dedede] border-t-primary',
      'rounded-full animate-spin',
    ],
    submitButton: [
      'shrink',
      'ml-0.5 lm:ml-2 py-1.25 px-1.75',
      'bg-light-gray font-medium text-base leading-6',
      'border border-[#dedede] rounded-[3px]',
      'cursor-pointer',
    ],
    dropdown: [
      'absolute top-full left-0 mt-1 p-0.5',
      'w-full min-w-80 max-h-[70vh] overflow-y-auto',
      'bg-white border border-gray-200 rounded shadow-lg z-50',
      'overflow-x-hidden',
    ],
    suggestionItem: 'w-full px-4 py-2 text-left text-sm text-textPrimary',
    noResults: ['px-4 py-3', 'text-sm text-gray-500'],
  },
  variants: {
    suggestionActive: {
      true: { suggestionItem: 'bg-gray-100' },
      false: { suggestionItem: 'hover:bg-gray-100' },
    },
    // Anchor the dropdown to a positioned ancestor (header actions) so it can span past the search bar to the language toggle's right edge
    wideDropdown: {
      true: {
        container: 'static',
        dropdown: 'right-4 w-auto',
      },
    },
  },
  defaultVariants: {
    suggestionActive: false,
    wideDropdown: false,
  },
});
